import { render, staticRenderFns } from "./WpBox.vue?vue&type=template&id=68e845b8&scoped=true"
import script from "./WpBox.vue?vue&type=script&lang=js"
export * from "./WpBox.vue?vue&type=script&lang=js"
import style0 from "./WpBox.vue?vue&type=style&index=0&id=68e845b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e845b8",
  null
  
)

export default component.exports